export default __webpack_public_path__ + "static/media/ic_star.a62a8e0f.png";